//export const BASE_URL = "http://localhost:3000";
export const BASE_URL = "https://api.olicloud.es";
// export const URL_ALMAZARA = "http://localhost:8080";
export const URL_ALMAZARA = "https://almazara.olicloud.es";
// export const URL_PRODUCTOR = "http://localhost:8080";
export const URL_PRODUCTOR = "https://productor.olicloud.es";